import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// Hooks
import { useAppContext } from '../store/AppContext';
// Permissions
import hasPermission from '../permissions/hasPermission';
import { redirectToCognitoLogin } from '../utils/cognitoAuth';

function ProtectedRoutes({ permission, children }) {
  // Hooks
  const location = useLocation();
  const [{ user, isAuthenticated }] = useAppContext();

  useEffect(() => {
    if (!isAuthenticated) {
      redirectToCognitoLogin();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return !permission || hasPermission(permission, user.prm)
    ? children
    : <Navigate to="/" state={{ from: location }} replace />;
}

ProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string,
};

ProtectedRoutes.defaultProps = {
  permission: null,
};

export default ProtectedRoutes;
